import React, { useEffect, useState } from 'react';
import { FolderPlus, Pencil, X } from 'lucide-react';
import api from '../../services/api';

const INITIAL_FORM = {
  nome: '',
  descricao: ''
};

const GrupoModal = ({ isOpen, onClose, refreshData, grupoParaEditar = null }) => {
  const [formData, setFormData] = useState(INITIAL_FORM);
  const isEditing = Boolean(grupoParaEditar);

  useEffect(() => {
    if (isOpen) {
      setFormData(
        grupoParaEditar
          ? {
              nome: grupoParaEditar.nome || '',
              descricao: grupoParaEditar.descricao || ''
            }
          : INITIAL_FORM
      );
    }
  }, [isOpen, grupoParaEditar]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      if (isEditing) {
        await api.put(`/dispositivos/grupos/${grupoParaEditar.id}`, formData);
        alert('Grupo atualizado com sucesso!');
      } else {
        await api.post('/dispositivos/grupos', formData);
        alert('Grupo criado com sucesso!');
      }
      await refreshData();
      onClose();
    } catch (error) {
      console.error(error);
      const detail = error.response?.data?.detail;
      alert(detail || `Erro ao ${isEditing ? 'atualizar' : 'criar'} grupo`);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm">
      <div className="w-full max-w-lg overflow-hidden rounded-2xl bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b bg-gray-50/50 p-6">
          <h2 className="flex items-center gap-2 text-xl font-bold text-slate-800">
            {isEditing ? (
              <Pencil size={24} className="text-condo-teal" />
            ) : (
              <FolderPlus size={24} className="text-condo-teal" />
            )}
            {isEditing ? 'Editar Grupo' : 'Criar Grupo'}
          </h2>
          <button onClick={onClose} className="text-gray-400 transition-colors hover:text-red-500">
            <X size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5 p-6">
          <div>
            <label className="mb-1 block text-sm font-semibold text-gray-700">Nome do Grupo</label>
            <input
              type="text"
              required
              value={formData.nome}
              onChange={(event) => setFormData({ ...formData, nome: event.target.value })}
              placeholder="Ex: Portaria Principal"
              className="w-full rounded-xl border border-gray-300 p-3 outline-none focus:ring-2 focus:ring-slate-900"
            />
          </div>

          <div>
            <label className="mb-1 block text-sm font-semibold text-gray-700">Descrição</label>
            <textarea
              rows="3"
              value={formData.descricao}
              onChange={(event) => setFormData({ ...formData, descricao: event.target.value })}
              placeholder="Ex: Faciais do acesso principal e guarita."
              className="w-full rounded-xl border border-gray-300 p-3 outline-none focus:ring-2 focus:ring-slate-900"
            />
          </div>

          <button type="submit" className="mt-2 w-full rounded-xl bg-slate-900 py-4 font-bold text-white transition hover:bg-slate-800">
            {isEditing ? 'Salvar Alterações' : 'Salvar Grupo'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default GrupoModal;
